module.exports = __webpack_public_path__ + "static/media/Challenge-Post-test-01.00547d89.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vo/Challenge-Post-test-01.mp3
// module id = 597
// module chunks = 0